import { NavLink } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import './LeftSidebar.scss';
import { menu } from './mainMenuData';
import { useState } from 'react';
import LeftSidebarBottom from './LeftSidebar_bottom';

function LeftSidebar() {
  // Initialize with MainMenu (id: 1) and Management (id: 2) open
  const [openItems, setOpenItems] = useState({
    1: true,  // Main Menu
    2: true   // Management
  });

  const toggleItem = itemId => {
    setOpenItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  return (
    <div className="sidebar-wrapper">
      <div className="logo">
        <NavLink to="/dashboard">
          <img src="/ezsalons-logo-white.png" style={{ width: '200px' }} alt="logo" />
        </NavLink>
      </div>
      <div className="menu-container">
        <div className="menu">
          {menu.map(item => (
            <div className="item" key={item.id}>
              <div
                className="title flex items-center justify-between cursor-pointer text-gray-400"
                onClick={() => toggleItem(item.id)}
              >
                <span className="text-gray-400">{item.title}</span>
                <ChevronRight
                  className={`h-4 w-4 transition-transform duration-200 text-gray-400 ${
                    openItems[item.id] ? 'rotate-90' : ''
                  }`}
                />
              </div>
              <div
                className={`overflow-hidden transition-all duration-200 ${
                  openItems[item.id] ? 'max-h-96' : 'max-h-0'
                }`}
              >
                {item.listItems.map(listItem => {
                  const IconComponent = listItem.icon;
                  return (
                    <NavLink to={listItem.url} key={listItem.id} className="listItem">
                      <IconComponent className="w-4 h-4" />
                      <span>{listItem.title}</span>
                    </NavLink>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <LeftSidebarBottom />
      </div>
    </div>
  );
}

export default LeftSidebar;
